const PLATFORM_ASK_EXACT = new Set([
  '/',
  '/maintenance',
  '/search',
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/business-registration',
  '/registration-success',
  '/account-verification-sent',
  '/invitation',
  '/customer-signup',
  '/privacy',
  '/features',
  '/business-challenge',
  '/business-challenge/official-rules',
  '/blog',
  '/blog/new',
  '/blog-admin',
  '/verify-email',
  '/help-support',
  '/dashboard/platform',
  '/dashboard/platform/profile',
]);

const PLATFORM_ASK_PREFIXES = ['/agreements/', '/blog/', '/dashboard/platform/'];

export function isPlatformAskAiPath(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (PLATFORM_ASK_EXACT.has(path)) return true;
  return PLATFORM_ASK_PREFIXES.some((prefix) => path.startsWith(prefix) || pathname.startsWith(prefix));
}
